var map = {
	"./_footer": "s9Hj",
	"./de_footer": "50cy",
	"./es_footer": "vb9n",
	"./fr_footer": "kEmP",
	"./keto_footer": "Fip5",
	"./pt_footer": "9xya"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZuQg";